import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Button from 'carbon-react/lib/components/button';

import { Integration } from '@futrli-sdk/app-store';

import * as styles from './integration-start.scss';
import { TechnicalIssues } from '../technical-issues/technical-issues';

interface Props {
  activeIntegrationId?: string;
  error?: boolean;
  imageOverride?: string;
  connectTextOverride?: ReactElement;
  integration: Integration;
  onClick?: (integration: Integration) => Promise<void>;
}

export const IntegrationStart = ({
  activeIntegrationId,
  error,
  imageOverride,
  connectTextOverride,
  integration,
  onClick
}: Props) => {
  const busy = integration.id === activeIntegrationId;
  const disabled = typeof activeIntegrationId === 'string';
  const showError = error && busy;

  return (
    <>
      <div
        className={classNames(styles.container, { [styles.disabledContainer]: disabled })}
        onClick={() => onClick?.(integration)}
      >
        <img
          src={imageOverride || integration.image}
          alt={`Logo ${integration.name}`}
          style={{ width: 40, height: 40 }}
        />
        <div className={styles.integrationTitle}>{integration.name}</div>
        <Button ml="auto" buttonType="primary">
          {busy ? (
            <FormattedMessage id="common.connecting" defaultMessage="Connecting" />
          ) : (
            connectTextOverride || <FormattedMessage id="common.connect" defaultMessage="Connect" />
          )}
        </Button>
      </div>
      {showError && (
        <div className={styles.errorMessageWrapper}>
          <TechnicalIssues />
        </div>
      )}
    </>
  );
};
